export default __webpack_public_path__ + "static/virsat-loading-page-background-mobile-738a916ca5b2781bfd00e362a9ad304f.jpg";